const state = {
    clientSize: {}, // 页面宽高
    fullScreenLoading: false,   // 全局loading 状态
    isCollapse: false,  // 左侧菜单栏 是否折叠
    curProjectId: '', // 当前项目的 ID
    taskId:'', //任务id
    taskFlag:'',// 设置任务标志（提交审核or查看）
    btnStatus: false,
    projectInfo: {},    // 项目信息（审计系统推送的）
}

const mutations = {
    SET_CLIENT_SIZE: (state, obj) => {
        state.clientSize = obj
    },
    SET_FULL_LOADING: (state, value) => {
        state.fullScreenLoading = value
    },
    SET_COLLAPSE: (state, value) => {
        state.isCollapse = value
    },
    SET_CUR_PROJECTID: (state, projectId) => {
        state.curProjectId = projectId
    },
    SET_TASKID: (state, taskId) => {
        state.taskId = taskId
    },
    SET_TASK_FLAG: (state, taskFlag) => {
        state.taskFlag = taskFlag
    },
    SET_BTN_STATUS: (state, status) => {
        state.btnStatus = status
    },
    SET_PROJECTINFO: (state, params) => {
        state.projectInfo = params
    }
}

const actions = {
    // 设置窗口
    setClientSize({ commit }, obj) {
        commit('SET_CLIENT_SIZE', obj)
    },
    // 更新全局加载框状态
    setFullLoading({ commit }, value) {
        commit('SET_FULL_LOADING', value)
    },
    // 设置左侧菜单栏 折叠状态
    setCollapse({ commit }, value) {
        commit('SET_COLLAPSE', value)
    },
    // 设置 项目ID
    setProjectId({ commit }, projectId) {
        commit('SET_CUR_PROJECTID', projectId)
    },
    // 设置任务ID
    setTaskId({ commit }, taskId) {
        commit('SET_TASKID', taskId)
    },
    // 设置任务标志（提交审核or查看）
    setTaskFlag({ commit }, taskFlag) {
        commit('SET_TASK_FLAG', taskFlag)
    },
    // 设置全局操作按钮状态
    setBtnStatus({ commit }, status) {
        commit('SET_BTN_STATUS', status)
    },
    // 设置项目信息
    setProjectInfo({ commit }, params) {
        commit('SET_PROJECTINFO', params)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}